/* ===== Hostname ===== */
const hostname = "lolol.com";
// const hostname = "new.lolol.com";
// const hostname = "localhost";
/* ===== END Hostname  ===== */

/* ===== API env ===== */
const env = "Live";
// const env = "Stage";
// const env = "Dev";
/* ===== END API env ===== */

/* ===== Version ===== */
const version = "2.48.2";
/* ===== END Version ===== */

const checkPathName = () => {
  let path =
    window.location.hostname === hostname ? "/" : `https://${hostname}`;

  return path;
};
const path = checkPathName();

const apiHost = {
  Live: "https://api-live-web.lolol.com",
  Stage: "https://api-stage-web-new.lolol.com",
  Dev: "http://129.126.133.187"
};

const crossOrigin = "https://cors-anywhere.herokuapp.com";
const google_api_key = "AIzaSyDA_qABMV4_sX8lFgWbg-geqTV7VVTZAaI";

export { env, version, hostname, apiHost, crossOrigin, path, google_api_key };
export default {
  apiUrl: "http://yoursite.com/api/"
};
